import { Card, Button } from 'src/components/UIComponents'
import messages from './AccesUtilisateur.json'

export default {
  name: 'AccesUtilisateur',
  i18n: messages,

  components: { Card, [Button.name]: Button },

  data() {
    return {
      data: null,
      control: {
        emptyResult: null,
      },
    }
  },

  mounted() {
    this.updateData()
  },

  methods: {
    /**
     * Get data from backend
     */
    updateData() {
      this.$eventHub.$emit(this.$eventHub.LOADING.START)
      this.$axios.get('rest/bd/acces/utilisateur/' + this.$store.getters.user.id).then(
        response => {
          this.updateDataSuccess(response.data)
          this.$eventHub.$emit(this.$eventHub.LOADING.END)
        },
        error => {
          this.updateDataFailed(error.response)
          this.$eventHub.$emit(this.$eventHub.LOADING.END)
        }
      )
    },

    /**
     * Appelé lorsque la récupération des données s'est bien passée
     */
    updateDataSuccess(data) {
      if (this.$val.isDefined(data.accesApplication) && data.accesApplication.length > 0) {
        this.data = data
        this.control.emptyResult = false
      } else {
        this.control.emptyResult = true
      }
    },

    /**
     * Appelé lorsque la récupération des données s'est mal passée
     */
    updateDataFailed(reponse) {
      //on notifie l'erreur a l'utilisateur
      this.$notify({
        title: this.$t('notifications.echecRecuperationDonnees.title'),
        message: this.$t('notifications.echecRecuperationDonnees.message'),
        horizontalAlign: 'right',
        verticalAlign: 'bottom',
        type: 'danger',
        timeout: 5000,
        closeOnClick: true,
      })
    },

    /**
     * Lance un appel pour pour MAJ du refresh token + réception du lien à jour pour ouvrir une nouvelle fenetere
     * @param {*} application
     */
    gotoApp(application) {
      console.log(application)
      this.sendLogAcces(application.libelle)
      this.$eventHub.$emit(this.$eventHub.LOADING.START)
      this.$axios
        .get('rest/bd/acces/application?idApplication=' + application.id)
        .then(
          response => {
            console.log(response.data)
            // 1. Màj du token
            localStorage.setItem('refreshToken', response.data.refreshToken)

            // 2. Ouverture de l'application dans un nouvel onglet
            window.open(response.data.url, '_blank')
          },
          error => {
            this.updateDataFailed(error.response)
          }
        )
        .finally(() => {
          this.$eventHub.$emit(this.$eventHub.LOADING.END)
        })
    },

    /**
     * Permet de logguer l'appli cliquée
     * */
    sendLogAcces(libelle) {
      this.$eventHub.$emit(this.$eventHub.SEND_LOG, this.getTypeLog(libelle), null)
    },

    /**
     * Récupère l'énum en fonction du libellé de l'appli
     * @param {} libelle
     */
    getTypeLog(libelle) {
      let typeLog = ''
      switch (libelle) {
        case 'Yard dangereux':
          typeLog = 'APPLI_YARD'
          break
        case 'Module Rendez vous':
          typeLog = 'APPLI_MODRDV'
          break
        case 'Pesage':
          typeLog = 'APPLI_PESAGE'
          break
        default:
          typeLog = 'APPLICATION'
      }
      return typeLog
    },
  },
}
